<template>
  <div v-if="!!interac">
    <p v-html="trans('interac_instructions')"></p>
    <b-form-group :label="trans('email')">
      <b-input-group>
        <b-form-input size="sm" :value="interac.email" readonly />
        <b-input-group-append>
          <b-button variant="success" size="sm" v-clipboard:copy="interac.email" :title="trans('copy')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-copy"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group :label="trans('message_comment')">
      <b-input-group>
        <b-form-input size="sm" :value="interac.message" readonly />
        <b-input-group-append>
          <b-button variant="success" size="sm" v-clipboard:copy="interac.message" :title="trans('copy')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-copy"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <p v-if="!show_security" class="text-left">
      <small>
        <a href="#" class="p-0 text-primary" @click.prevent="show_security = true">
          {{ trans('interac_autodeposit_message') }}
        </a>
      </small>
    </p>
    <b-form-group v-if="show_security" :label="trans('security_question')">
      <b-input-group>
        <b-form-input size="sm" :value="interac.question" readonly />
        <b-input-group-append>
          <b-button variant="success" size="sm" v-clipboard:copy="interac.question" :title="trans('copy')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-copy"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group v-if="show_security" :label="trans('security_answer')">
      <b-input-group>
        <b-form-input size="sm" :value="interac.answer" readonly />
        <b-input-group-append>
          <b-button variant="success" size="sm" v-clipboard:copy="interac.answer" :title="trans('copy')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-copy"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <p v-html="trans('interac_instructions2')"></p>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      interac: Object,
    },
    data() {
      return {
        trans: trans,
        show_security: this.organization.interac_ask_security_answer,
      }
    },
  }
</script>